import { useEffect, useState, type FormEvent } from "react";
import { get, type Me, type Trip } from "../lib/api.ts";
import { landingSection, Link, navigate, tripPath } from "../lib/router.tsx";

const STATE_LABEL: Record<Trip["state"], string> = {
  DRAFT: "Not started",
  SCHEDULED: "Scheduled",
  ACTIVE: "Capturing now",
  ENDED: "Ended",
  ARCHIVED: "Archived",
};

export function TripsPage({ me }: { me: Me }) {
  const [trips, setTrips] = useState<Trip[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [token, setToken] = useState("");

  const load = async () => {
    const all = await Promise.all(me.memberships.map((m) => get<Trip>(`/v1/trips/${m.tripId}`)));
    setTrips(all);
  };
  useEffect(() => {
    load().catch((e: Error) => setError(e.message));
  }, []);

  // Joining always goes through the join page, which asks what to share before anything is shared.
  function redeem(e: FormEvent) {
    e.preventDefault();
    navigate(`/invite#token=${encodeURIComponent(token.trim())}`);
  }

  return (
    <section className="stack">
      <h1>Your trips</h1>
      {error && (
        <p role="alert" className="error">
          {error}
        </p>
      )}
      {trips === null ? (
        <p className="muted">Loading…</p>
      ) : trips.length === 0 ? (
        <p className="muted">No trips yet. Create one, or join with an invitation.</p>
      ) : (
        <ul className="cards">
          {trips.map((t) => (
            <li key={t.id}>
              <Link className="card" to={tripPath(t.id, landingSection(t.roles))}>
                <strong>{t.name}</strong>
                <span className={`pill ${t.state.toLowerCase()}`}>{STATE_LABEL[t.state]}</span>
                <span className="muted">{t.roles.join(" · ").toLowerCase()}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
      <div className="row wrap">
        <Link className="button primary" to="/trips/new">
          New trip
        </Link>
        <form onSubmit={redeem} className="row grow">
          <label className="grow">
            <span className="sr">Invitation code</span>
            <input
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="Paste invitation code"
              minLength={43}
              maxLength={43}
              required
            />
          </label>
          <button className="button">Join trip</button>
        </form>
      </div>
    </section>
  );
}
